<template>
  <div id="personCenter">
    <Header2></Header2>
    <div class="centerBox">
      <div class="top ">
        <div class="topInset clearfix">
          <div class="left">
            <img src="@/assets/imgs/logo.png" alt="">
          </div>
          <div class="searchBox">
            <div class="ipt">
              <input type="text" v-model="keywords" @click="intoSearch(keywords,$event)" placeholder="请输入要搜索的内容">
            </div>
            <a class="search" href="javascript:;" @click="intoSearch(keywords)">搜索</a>
          </div>
        </div>
      </div>
      <div class="listBox inner clearfix">
        <div class="innerLeft">
          <div class="topTitle">
            <div class="titleLine">
              <a href="javascript:;" class="follow" :class="tabIndex==0?'active':''" @click="changeTab(0)">关注</a>
              <a href="javascript:;" :class="tabIndex==1?'active':''" @click="changeTab(1)">粉丝</a>
            </div>
          </div>
          <div class="tzList">
            <div class="newsList" v-if="tabIndex==0">
                <ul>
                  <li class="clearfix" v-for="(item,i) in follows" :key="i">
                    <div class="left clearfix" @click="intoPerson">
                      <img :src="item.avatar" alt="">
                      <span>{{item.username}}</span>
                    </div>
                    <div class="right" :class="item.mutual==1 ?'attend':''">
                      <a href="javascript:;" @click="attend2(item)">{{item.mutual ==0?'已关注':'关注'}}</a>
                    </div>
                  </li>
                </ul>
                <li v-if="follows.length > 0 && followsCompleted"
                  style="padding: 20px; color: #999; text-align: center; background: #fff;">
                  -- 已加载全部 --
                </li>
                <li v-if="follows.length== 0"
                  style="padding: 20px; color: #999; text-align: center; background: #fff;">
                  -- 暂无内容 --
                </li>
            </div>
            <div class="newsList" v-else>
                <ul>
                  <li class="clearfix" v-for="(item,i) in fans">
                    <div class="left clearfix" @click="intoPerson">
                      <img :src="item.avatar" alt="">
                      <span>{{item.username}}</span>
                    </div>
                    <div class="right" :class="item.mutual==1?'attend':''" @click="attend">
                      <a href="javascript:;" @click="attend2(item)">{{item.mutual==0?'已关注':'关注'}}</a>
                    </div>
                  </li>
                </ul>
                <li v-if="fans.length > 0 && fansCompleted" style="padding: 20px; color: #999; text-align: center; background: #fff;">
                  -- 已加载全部 --
                </li>
                <li v-if="fans.length==0" style="padding: 20px; color: #999; text-align: center; background: #fff;">
                  -- 暂无内容 --
                </li>
            </div>

          </div>
        </div>
        <div class="innerRight">
          <Rightbox @changeTab="changeTab" :name="follow"></Rightbox>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import service from '@/api/service/service';
  import Header2 from '../common/header2'
  import Rightbox from '../common/loginBox'
  import { storageData } from "@/assets/js/storage";

  export default {
    components: {
      Header2,
      Rightbox
    },

    data() {
      return {
        follow:this.$route.name, //获取当前页面的路由name
        tabIndex: 0,
        gzstatus: 0,
        // gzstatusone: '',
        keywords: '',
        follows: [], //关注列表
        fans: [], //粉丝列表
        followListPage: 1,
        fansListPage: 1,
        scrolling:false,//是否是滚动
        loading:false,
        followsCompleted:1,
        fansCompleted:1,
        userInfo:JSON.parse(localStorage.getItem('areaUserinfo'))
      }
    },
    mounted() {
      let _self = this
      _self.getfollows()
      //监听滚动
      window.addEventListener('scroll', () => {
        const HEAD_HEIGHT = 70
        const TAB_HEIGHT = 65
        if (document.documentElement.scrollTop + document.documentElement.clientHeight + HEAD_HEIGHT +
          TAB_HEIGHT >= document.documentElement.scrollHeight) {
          if (this.scrolling) return
          this.scrolling = true
          if (this.tabIndex === 0) {
            this.loadMorefollows()
          } else {
            this.loadMorefans()
          }
          const timer = setTimeout(() => {
            this.scrolling = false
            clearTimeout(timer)
          }, 300)
        }
      })
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', () => {}) //注意包含两个参数
      })
    },
    methods: {
      changeTab(tabIndex) {
        //  切换时, 当没数据时才重新调用接口
        this.tabIndex = tabIndex
        if (tabIndex === 0) {
          this.follows = []
          this.followListPage = 1
          this.getfollows()
        }else{
          this.fansListPage = 1
          this.fans = []
          this.getfans()
        }
      },

      attend() {
        if (this.gzstatus == 0) {
          this.gzstatus = 1
        } else {
          this.gzstatus = 0
        }
      },
      // 关注
      attend2(item) {
          if(item.mutual == 0){//取消关注
            service.post(`${this.commonIp}/v1/follows/deleteFans`,{
              openId:item.openId
            })
            .then((res)=>{
              if(res.data.code == '200') {
                // 关注
                item.mutual = 1
              }
            })
            .catch((err)=>{
            })
          }else{
            service.post(`${this.commonIp}/v1/follows/addFans`,{
              openId:item.openId
            })
            .then((res)=>{
              if(res.data.code == '200') {
                item.mutual = 0
              }
            })
            .catch((err)=>{
            })
          }
      },
      intoPerson() {
        this.$router.push({
          path: '/pcenter'
        })
      },
      intoSearch(val,e) {
        if(e && e.keyCode != '13') {
            return
        }else{
          this.$router.push({
            path: `/search?keywords=${val}`
          })
        }
      },
      getfollows() {
        this.loading = true
        service.get(`${this.commonIp}/v1/follows/fans?openId=${this.userInfo.openId}&page=${this.followListPage}`)
          .then((res) => {
            if (res.data.code == 200) {
              const data = res.data.data
              const {results,hasMore} =data
              this.follows = [...this.follows, ...results]
              this.followsCompleted = hasMore ===0
            }
          })
          .catch(error => { //
            console.log(error)
          })
          .finally(()=>{
            this.loading = false
          })
      },
      getfans() {
        this.loading = true
        service.get(`${this.commonIp}/v1/follows/follow?openId=${this.userInfo.openId}&page=${this.fansListPage}`).then((res) => {
            if (res.data.code == 200) {
              const data = res.data.data
              const {results,hasMore} =data
              this.fans = [...this.fans , ...results]
              this.fansCompleted = hasMore ===0
            }
          })
          .catch(error => { //
            console.log(error)
          })
          .finally(()=>{
            this.loading = false
          })
      },
      loadMorefollows() { //滚动加载
        //  当正在加载数据活动数据已经全部加载完毕后, 不再调用接口
        if (this.loading || this.followsCompleted) return
        this.followListPage += 1
        this.getfollows()
      },
      loadMorefans() {
        if(this.loading || this.fansCompleted) return
        this.fansListPage += 1
        this.getfans()
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@/assets/less/index.less';
  // ::-webkit-scrollbar {
  //   //去掉浏览器滚动条f
  //   display: none;
  // }

  // .followBox,
  // .fansBox {
  //   height: 1500px;
  //   overflow-y: scroll;
  // }

  #personCenter {
    background: #f2f2f2;
    padding-bottom:300px;
    .centerBox {
      width: 100%;
      .top {
        padding-top:20px;
        background-color: #fff;
        width: 100%;
        margin: 0 auto;
        // padding:20px 126px 0 126px;
        box-sizing: border-box;
        background: #fff;
        margin: 0 0 20px 0;
        .topInset {
          margin: 0 auto;
          width: 1060px;
          height: 50px;
          // padding-top: 20px;
        }
        .left {
          .fl();
          img {
            width: 96px;
          }
        }
        .searchBox {
          .fr();
          .ipt {
            width: 228px;
            border: none;
            height: 38px;
            .fl();

            input {
              outline-style: none;
              outline-width: 0px;
              text-shadow: none;
              -webkit-appearance: none;
              -webkit-user-select: text;
              outline-color: transparent;
              padding: 0 0 0 8px;
              outline: none;
              background: #f4f5f6;
              width: 222px;
              display: inline-block;
              height: 38px;
              border: 1px solid #d9d9d9;
              border-radius: 3px 0 0 3px;
              .fl();
            }
          }

          .search {
            .fl();
            width: 68px;
            height: 38px;
            border-radius: 0 3px 3px 0;
            background: #208bdc;
            display: inline-block;
            color: #fff;
            text-align: center;
            line-height: 38px;
          }
        }
      }

      .inner {
        width: 1060px;
        min-width: 1060px;
      }

      .listBox {
        .noList {
          height: 40px;
          line-height: 40px;
          color: #999;
          text-align: center;
        }

        .innerLeft {
          margin-left: 0;
          width: 740px;

          .fl();
          background: #fff;

          .topTitle {
            border-bottom: 2px solid #efefef;

            .titleLine {
              padding: 20px;
              padding-bottom: 0;

              a {
                height: 40px;
                display: inline-block;
                color: #323232;
                font-size: 18px;
                position: relative;

                &.follow {
                  margin-right: 32px;
                }

                &.active {
                  color: #ea5d3c;
                }

                &.active::after {
                  content: "";
                  display: block;
                  position: absolute;
                  bottom: -2px;
                  left: 0;
                  width: 40px;
                  height: 2px;
                  background: #ea5d3c;
                }
              }
            }
          }
        }

        .innerRight {
          .fr();
          width: 295px;
        }
      }

      .tzList {
        .loadstyle {
          color: #999;
          text-align: center;
          height: 40px;
          line-height: 40px;
        }

        .newsList {

          li {
            padding: 20px;
            box-sizing: border-box;
            line-height: 50px;
            div:first-child {
              height: auto;
            }
            .left {
              .fl();

              img {
                width: 50px;
                height: 50px;
                .fl();
                border-radius: 50%;
              }

              span {
                font-size: @ft20;
                color: #323232;
                margin: 0 0 0 20px;
                cursor: pointer;
                .fl();
              }
            }

            .right {
              .fr();
              width: 84px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              border-radius: 3px;
              margin-top: 10px;
              padding-left: 15px;
              background: url('~@/assets/imgs/dh.png') no-repeat 10px center #d8d8d8;

              &.attend {
                background-color: #208bdc;
                background-image: url('~@/assets/imgs/ah.png');
                background-position: 15px center;

                a {
                  color: #fff;
                }
              }

              a {
                color: #323232;
              }
            }
          }
        }
      }
    }

    #loginBox {
      .ornot_login {
        margin: 0;
        padding: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/follow/follow.vue